// removed by extract-text-webpack-plugin
module.exports = {"link":"_14v-glFCun link","padTop":"_3K0BWn7Lnu"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/common/MDPatientSheet/MDPatientSheet.module.less
// module id = 960
// module chunks = 3